<template>
  <div>
    <div class="cascader-item">
      <div
        class="cascader-item-con border-1px"
        @click="clickHandle"
      >
        <span
          v-if="desc"
          class="left desc"
        >
          {{ desc }}
        </span>
        <span
          v-else
          style="color: #d6d6d6;"
        >
          {{ $t('message["855"]') }}
        </span>
        <i class="iconfont icon-angle-right iconicon-test18" />
      </div>
      <i
        v-if="canDelete"
        class="iconfont icon-angle-right iconicon-test35"
        @click="removeHandle"
      />
    </div>

    <div
      v-if="val && val.length && val[val.length - 1].showUrlInput"
      class="from-input"
    >
      <cube-input
        v-model="val[val.length - 1].inputVal"
        :placeholder="val[val.length - 1].inputPlaceholder || enterPlaceholder"
        class="input"
        @input="onInputUrl(val)"
      />
      <cube-validator
        ref="filterValidator"
        v-model="inputValValid"
        :model="val"
        :rules="rules"
        :messages="messages"
        :immediate="false"
      />
    </div>
  </div>
</template>
<script>
import MembersCascader from '@/components/mobile/Members'
import Vue from 'vue'
import { createAPI } from 'cube-ui'
createAPI(Vue, MembersCascader, ['select', 'cancel', 'confirm'], true)

export default {
  components: {
    // Members
  },
  props: {
    canDelete: {
      type: Boolean,
      default: false
    },
    source: {
      type: Array,
      default: () => []
    },
    fieldKey: {
      type: String,
      default: ''
    },
    fieldType: {
      type: String,
      default: ''
    },
    val: {
      type: [Object, Array],
      default: null
    },
    defaultValue: {
      type: [Object, Array],
      default: null
    }
  },
  data () {
    const { defaultValue } = this
    let routes = []
    let maps
    // console.log(defaultValue)
    if (this.fieldKey === 'from_info' || this.fieldType === 'select_reception') {
      routes = defaultValue || []
    } else {
      maps = {
        groupid: {},
        roleid: {},
        userid: {}
      }
      const { source = [] } = this
      const loop = (list) => {
        if (list && list.length) {
          list.forEach(item => {
            const { id, keyname, children } = item
            if (keyname) {
              maps[keyname][id] = item
              loop(children)
            }
          })
        }
      }
      loop(source)

      routes = []
      Object.keys(defaultValue).forEach(key => {
        const id = defaultValue[key]
        if (maps[key][id]) {
          routes.push(maps[key][id])
        }
      })
      // console.log(source)
    }
    return {
      maps,
      routes,
      show: false,
      lists: [],
      inputValValid: false,
      rules: {

      },
      messages: {

      }
    }
  },
  computed: {
    desc () {
      let desc = ''
      if (this.routes && this.routes.length) {
        desc = this.routes && this.routes.map(item => (item.name || item.fieldname)).join(' / ')
      }
      return desc
    },
    enterPlaceholder () {
      return this.$t('message["751"]')
    }
  },
  created () {
    if (this.fieldKey === 'from_info') {
      this.rules.custom = this.validateFromUrl
    }
  },
  methods: {
    clickHandle () {
      let _this = this
      this.show = true
      let instance = MembersCascader && MembersCascader.$create({
        $props: {
          visible: this.show,
          defaultValue: this.routes,
          sourceDatas: this.source
        },
        $attrs: {
          ref: 'members'
        },
        $class: {
          'members': true
        },
        $events: {
          change: this.changeHandle,
          update: (val) => {
            _this.show = val
          }
        }
      })
      instance.onShow()
    },
    changeHandle ({ value }) {
      this.$emit('change', value)
      this.show = false
      this.routes = value
    },
    removeHandle () {
      this.$emit('remove')
    },
    onInputUrl (val) {
      if (val.value && val.value[1]) {
      }
      this.$refs.filterValidator && this.$refs.filterValidator.validate()
    },
    validate (cb) {
      this.$refs.filterValidator && this.$refs.filterValidator.validate(cb)
    },
    validateFromUrl (val) {
      console.log(111, val, val[val.length - 1], val[val.length - 1].inputVal)
      if (val && val[val.length - 1] && val[val.length - 1].inputVal !== '') {
        return true
      } else {
        this.messages.custom = this.$t('message["751"]') + '' + val[1].name
        return false
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.cascader-item {
  display: flex;
  justify-content: space-between;
  height: 48px;
  line-height: 48px;
  padding: 0 16px;
  color: #333;
  font-size: 16px;
  margin-bottom: 16px;
  .cascader-item-con {
    border: 1px solid #d6d6d6;
    border-radius: 2px;
    padding: 0 12px;
    width: 92%;
    display: flex;
    justify-content: space-between;
    .iconicon-test18 {
      color: #d6d6d6;
    }
  }
  .iconicon-test35 {
    color: #f57676;
  }
  .desc {
    text-overflow: ellipsis;
    overflow: hidden;
  }
}
.from-input {
  // width: 90%;
  // border: 1px solid #ccc;
  .cube-input {
    width: 82%;
    margin: 0 16px 12px;
  }
  .cube-validator {
    width: 82%;
    margin: 0 16px 12px;
  }
}
</style>
